import type { ListBuilderList } from '../../../types';
import { createTripColumnsWithoutDate } from '../columns';

/**
 * Today's Trips list configuration
 * Shows trips dated today.
 *
 * The date filter MUST use the registered `routeDateRange` date-range filter
 * (objectTable 'route', dateField 'date') with a `data: { startDate, endDate }`
 * payload — the same shape every other "today" list uses (see
 * order/lists/todays-orders.ts). The previous `routeDateFrom` / `routeDateTo`
 * keys were never registered in the filter registry, so
 * FilterService.transformFiltersForBackend dropped them and the list returned
 * EVERY trip regardless of date (PD-13732).
 */
export const todaysTripsList: ListBuilderList = {
	id: 'todays-trips',
	name: "Today's Trips",
	type: 'default',
	active: true,
	cacheTTL: 300000,
	filterRules: {
		routeDateRange: {
			defaultValue: [
				{
					id: 'today',
					label: 'Today',
					data: {
						startDate: '{{DATE:0d}}',
						endDate: '{{DATE:0d}}',
					},
				},
			],
		},
	},
	columns: createTripColumnsWithoutDate(),
	defaultSortId: 'status-asc',
	sortOrder: 1,
};
